module.exports = __webpack_public_path__ + "img/brand@1x.2718fdc0.png";